import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Users,
  CreditCard,
  History,
  ArrowLeft,
  ArrowRight,
  Wallet
} from 'lucide-react';

/**
 * PAGE: PAIEMENTS MUTUALISTES (ADMIN) - NIVEAU 2
 * 
 * Modules de paiement pour les mutualistes
 */

const AdminPaymentsMutualistes = () => {
  const navigate = useNavigate();

  const modules = [
    {
      title: 'Paiements',
      subtitle: 'Paiements tiers',
      description: 'Enregistrer des paiements pour le compte des mutualistes',
      icon: CreditCard,
      path: '/payments/third-party',
      color: 'blue'
    },
    {
      title: 'Paiements Unifiés',
      subtitle: 'Recettes & Dépenses',
      description: 'Gérer tous types de paiements (cotisations, prêts, remboursements, etc.)',
      icon: Wallet,
      path: '/payments/unified',
      color: 'purple'
    },
    {
      title: 'Historique',
      subtitle: 'Historique des paiements',
      description: 'Consulter et gérer tous les paiements mutualistes',
      icon: History,
      path: '/payments/history-mutualiste',
      color: 'green'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      blue: 'bg-blue-100 text-blue-600 group-hover:bg-blue-200 hover:border-blue-300',
      purple: 'bg-purple-100 text-purple-600 group-hover:bg-purple-200 hover:border-purple-300',
      green: 'bg-green-100 text-green-600 group-hover:bg-green-200 hover:border-green-300'
    };
    return colors[color] || colors.blue;
  };

  return (
    <div className="space-y-6">
      {/* En-tête avec bouton retour */}
      <div className="bg-white rounded-xl shadow-card p-6">
        <button
          onClick={() => navigate('/admin/payments')}
          className="flex items-center text-gray-600 hover:text-primary-600 mb-4 transition-colors duration-200"
        >
          <ArrowLeft className="h-5 w-5 mr-2" />
          <span className="text-sm font-medium">Retour aux paiements</span>
        </button>

        <div className="flex items-center">
          <div className="p-3 rounded-lg bg-blue-100 text-blue-600 mr-4">
            <Users className="h-8 w-8" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-primary-900 mb-1">
              Paiements Mutualistes
            </h1>
            <p className="text-gray-600">
              Gestion des paiements individuels
            </p>
          </div>
        </div>
      </div>

      {/* Cartes des modules */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {modules.map((module, index) => (
          <button
            key={index}
            onClick={() => navigate(module.path)}
            className={`bg-white rounded-xl shadow-card p-8 text-left hover:shadow-xl transition-all duration-200 transform hover:-translate-y-1 group border-2 border-transparent ${getColorClasses(module.color)}`}
          >
            <div className="flex flex-col items-center text-center">
              <div className={`p-6 rounded-2xl mb-6 transition-colors duration-200 ${
                module.color === 'blue' 
                  ? 'bg-blue-100 text-blue-600 group-hover:bg-blue-200' 
                  : module.color === 'purple'
                  ? 'bg-purple-100 text-purple-600 group-hover:bg-purple-200'
                  : 'bg-green-100 text-green-600 group-hover:bg-green-200'
              }`}>
                <module.icon className="h-16 w-16" />
              </div>
              
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                {module.title}
              </h2>
              
              <p className="text-sm font-medium text-gray-700 mb-3">
                {module.subtitle}
              </p>
              
              <p className="text-gray-600 mb-6">
                {module.description}
              </p>

              <div className={`flex items-center text-sm font-semibold ${
                module.color === 'blue' 
                  ? 'text-blue-600' 
                  : module.color === 'purple'
                  ? 'text-purple-600'
                  : 'text-green-600'
              }`}>
                <span>Accéder</span>
                <ArrowRight className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform duration-200" />
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default AdminPaymentsMutualistes;
